module.exports = __webpack_public_path__ + "img/about-1.1e017869.png";